import _ from 'lodash';

export function verify(modifiers = [], param = [], callback) {
  const temp = _.cloneDeep(modifiers);
  param.forEach((item, index) => { temp[index].value = item });
  let Switch = true;
  for (let i = 0; i < temp.length; i += 1) {
    if (temp[i].min) {
      if (_.isEmpty(temp[i].value)) {
        if (callback) callback(temp[i].name, temp[i].min, temp[i].id)
        Switch = false;
        break;
      }
      const isArray = Array.isArray(temp[i].value);
      if (isArray && temp[i].value.length < temp[i].min) {
        if (callback) callback(temp[i].name, temp[i].min, temp[i].id)
        Switch = false;
        break;
      }
    }
  }
  return Switch;
}
